import {
  InMemoryHeader,
  InMemoryString,
  InMemoryDate,
  InMemoryBoolean,
} from "pbas-vue-components";
import { translate2 } from "../trans2";
import { i18n } from '@/plugins/i18n';

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
});

const BillingImportTermHeaders = [
  new InMemoryHeader({
    type: new InMemoryString("Identifier"),
    visible: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new InMemoryHeader({
    title: "globals.employer",
    type: new InMemoryString("Employer/Translations[]/Name", {
      getString: (item) => translate2(item.Employer, "Name")
    }),
    visible: true,
    allowVisibilityChange: true,
    sortable: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "headers.billingimportterm.custom",
    type: new InMemoryBoolean("IsCustom"),
    visible: true,
    allowVisibilityChange: true,
    sortable: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "globals.start_date",
    type: new InMemoryDate("StartDate"),
    sortable: true,
    visible: true,
    searchable: true
  }),
  new InMemoryHeader({
    title: "components.plancreationwizard.membereligibility.period",
    type: new InMemoryString("TimeUnit", {
      getString: (item) => (item.TimeUnit !== null && item.TimeUnit !== undefined && i18n.t("enums." + item.TimeUnit)) || ""
    }),
    visible: true,
    allowVisibilityChange: true,
    sortable: true,
    searchable: true,
  }),
  new InMemoryHeader({
    title: "headers.billingimportterm.frequency",
    type: new InMemoryString("Frequency"),
    visible: true,
    allowVisibilityChange: true,
    sortable: true,
    searchable: true,
  }),
];
export default BillingImportTermHeaders;
